var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li>\n            <a class=\"send_later_selected_send_later_time\" tabindex=\"0\">"
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Schedule for {formatted_send_later_time}",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":7,"column":72},"end":{"line":7,"column":121}}}))
    + "</a>\n        </li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<ul id=\"send_later_popover\" class=\"nav nav-list\">\n    <li>\n        <a class=\"open_send_later_modal\" tabindex=\"0\">"
    + alias2(lookupProperty(helpers,"t").call(alias1,"Schedule message",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":3,"column":54},"end":{"line":3,"column":79}}}))
    + "</a>\n    </li>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"formatted_send_later_time"),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":9,"column":11}}})) != null ? stack1 : "")
    + "    <hr />\n    <li>\n        <a href=\"#scheduled\" tabindex=\"0\">"
    + alias2(lookupProperty(helpers,"t").call(alias1,"View scheduled messages",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":12,"column":42},"end":{"line":12,"column":74}}}))
    + "</a>\n    </li>\n</ul>\n";
},"useData":true});